import { render, staticRenderFns } from "./AulaSwitch.vue?vue&type=template&id=8b3fa370&scoped=true&"
import script from "./AulaSwitch.vue?vue&type=script&lang=ts&"
export * from "./AulaSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./AulaSwitch.vue?vue&type=style&index=0&id=8b3fa370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3fa370",
  null
  
)

export default component.exports